module.exports = __webpack_public_path__ + "static/media/temp.86d255b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/temp.svg
// module id = 652
// module chunks = 36